// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"1ddfe8bc","239":"1e627ee4","339":"1282b400","453":"eca5f793","797":"db217cf7","855":"cba394b8"}[chunkId] + ".chunk.js";
};